import React, { useEffect, useState } from "react";
// import { RiMenu3Fill } from "react-icons/ri";
import { LiaTimesSolid } from "react-icons/lia";
import Logo from "../assets/icons/CIMD LOGO 2.png";
import { FiMenu } from "react-icons/fi";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init();

const Navbar = () => {
  const navMenu = [
    { id: 1, path: "/", link: "home", text: "Home" },
    { id: 2, path: "/about", link: "about-us", text: "About Us" },
    { id: 3, path: "/services", link: "services", text: "Services" },
    { id: 4, path: "/contact-us", link: "contact", text: "Contact" },
    { id: 5, path: "/location", link: "location", text: "Location" },
    { id: 5, path: "/packages", link: "packages", text: "Packages" },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const hanldeMobileMenu = () => {
    setIsOpen(!isOpen);
  };

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Scroll to the top of the page on each navigation
    window.scrollTo(0, 0);
  }, [location.pathname]); // Triggered every time the path changes

  return (
    <div className="flex sticky top-0 bg-white z-[9999] items-center lg:px-24 md:px-10 px-4 py-3 justify-between shadow-lg">
      <div className="lg:text-xl cursor-pointer md:text-sm text-sm flex items-center md:gap-2 gap-1">
        <img onClick={() => navigate("/")} src={Logo} alt="" />
        {/* <p className="text-primaryPurple font-bold">Clear-Icon-Medical</p> */}
      </div>
      <ul className="lg:flex hidden gap-12 lg:gap-6 md:gap-4  items-center">
        {navMenu?.map((menu) => (
          <NavLink
            to={menu?.path}
            className={({ isActive }) =>
              `cursor-pointer  md:text-[0.75rem]    ${
                isActive
                  ? "  text-primaryPurple text-2xl lg:font-semibold lg:text-[0.95rem]"
                  : " text-gray-600 text-2xl lg:text-[0.95rem]"
              }`
            }
            key={menu?.id}
          >
            {menu?.text}
          </NavLink>
        ))}
      </ul>

      <button
        onClick={() => navigate("/book-appointment")}
        className="hidden lg:block rounded-full py-3 lg:px-7 md:px-5 bg-primaryPurple text-white md:text-[0.75rem] lg:text-sm"
      >
        Book appointment
      </button>

      {/* mobile-button */}
      <div className={`block lg:hidden `} onClick={hanldeMobileMenu}>
        {isOpen ? (
          <LiaTimesSolid className="text-3xl" />
        ) : (
          <FiMenu className="text-3xl" />
        )}
      </div>

      {/* mobile-menu */}
      {isOpen && (
        <motion.div
          className="fixed top-0 inset-0 z-20 flex"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {/* Overlay */}
          <div
            className="bg-black opacity-30 w-full h-full"
            onClick={() => setIsOpen(false)}
          ></div>
          <motion.section
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ duration: 0.4 }}
            className="bg-white px-6 h-[100%] w-[85%] pt-4 pb-10 flex flex-col justify-between lg:hidden fixed bottom-0 left-0 z-20 top-0"
          >
            <div className="flex flex-col gap-8">
              <div
                onClick={() => navigate("/")}
                className="lg:text-xl md:text-sm text-lg flex items-center md;gap-2 gap-1"
              >
                <img src={Logo} alt="" />
                <p className="text-primaryPurple font-bold">
                  Clear-Icon-Medical
                </p>
              </div>

              <ul className="flex flex-col gap-7">
                {navMenu?.map((menu) => (
                  <NavLink
                    to={menu?.path}
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) =>
                      `cursor-pointer ${
                        isActive
                          ? " text-primaryPurple font-semibold  text-[1.2rem]"
                          : "text-[1rem]  text-gray-600"
                      }`
                    }
                    key={menu?.id}
                  >
                    {menu?.text}
                  </NavLink>
                ))}
              </ul>
            </div>

            <button
              onClick={() => {
                setIsOpen(false);
                navigate("/book-appointment");
              }}
              className="rounded-full py-3 lg:px-7 md:px-5 bg-primaryPurple text-white md:text-sm lg:text-base"
            >
              Book appointment
            </button>
          </motion.section>
        </motion.div>
      )}
    </div>
  );
};
export default Navbar;
